export enum AppArea {
  MainSite = "mainSite",
  EmbedSite = "embedSite",
  Pdf = "pdf",
}
